import { getStore, setStore } from '../utils/storage';
import CreatableSelect from 'react-select/creatable';
import InputGroup from 'react-bootstrap/InputGroup';
import { useState } from 'react';

const createOption = (label) => ({
    label,
    value: label
  });

function Filter({ setFilter, isLoading, historyKey, placeholder }) {
    const { options:defaultOptions } = getStore(historyKey);
    const [options, setOptions] = useState(defaultOptions || []);
    const [value, setValue] = useState(null);

    function onChange(newValue) {
        setValue(newValue);
        const { value:searchTerm = '' } = newValue || {};
        setFilter(searchTerm);
    }

    function onCreate(searchTerm) {
        const newOption = createOption(searchTerm);
        const newOptions = [...options, newOption];
        setOptions(newOptions);
        setValue(newOption);
        setStore(historyKey, { options: newOptions, searchTerm })
        setFilter(searchTerm);
    }

    function onClearHistory() {
        setFilter('');
        setValue(null);
        setOptions([]);
        setStore(historyKey, { options: [], searchTerm: '' })
    }

    return (
        <InputGroup className='filter-group'>
            <CreatableSelect
                className='input-list'
                placeholder={placeholder}
                isClearable
                isDisabled={isLoading}
                isLoading={isLoading}
                onChange={onChange}
                onCreateOption={onCreate}
                options={options}
                value={value}
            />
            <button
                className="btn btn-norm" 
                title="Clear filter history"
                disabled={!options?.length}
                onClick={onClearHistory}
            >
                <i className="fa-lg fa-light fa-broom-wide"/>
            </button>
        </InputGroup>
    );
}

export default Filter;